import { Component } from "@angular/core";

@Component({
  selector: "plants-branding",
  imports: [],
  templateUrl: "./plants-branding.component.html",
  styleUrl: "./plants-branding.component.scss"
})
export class PlantsBrandingComponent {}
